import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IVendorPending from "../../../models/IVendorPending";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import ICatalog from "../../../models/ICatalog";
import IPrice_Group from "../../../models/IPrice_Group";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import UserContext from "../../../contexts/UserContext";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import UIService from "../../../services/UIService";
import UserService from "../../../services/UserService";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import IProcessVendorPendingDTO from "../../../models/DTO/IProcessVendorPendingDTO";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import uiContext from "../../../contexts/UiContext";
import UiContext from "../../../contexts/UiContext";

type Props = {
    vendorPending: IVendorPending;
    closeFn: () => void;
};

export const VendorPendingModal = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UiContext);

    const [catalogs, setCatalogs] = useState<ICatalog[]>([]);
    const [selectedCatalog, setSelectedCatalog] = useState<ICatalog | null>(null);
    const [selectedPriceGroup, setSelectedPriceGroup] = useState<IPrice_Group | null>(null);
    const [note, setNote] = useState("");
    const [createInQbo, setCreateInQbo] = useState(false);
    const [createInQbd, setCreateInQbd] = useState(false);
    const [active, setActive] = useState(false);

    const getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            onlyActive: true,
        };

        socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    const onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        setCatalogs(data.catalogs);
    };

    const processVendorPending = (status: "approve" | "reject") => {
        const payload: IProcessVendorPendingDTO = {
            vendorPendingGuid: props.vendorPending.guid,
            approved: status === "approve",
            note,
            create_in_qbo: createInQbo,
            create_in_qbd: createInQbd,
            catalog_id: selectedCatalog?.id,
            price_group_id: selectedPriceGroup?.id,
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.VendorProcessVendorPending, payload);

        setActive(true);
    };

    const onProcessVendorPending = (data: IProcessVendorPendingDTO) => {
        const notification: INotification = {
            message: "successfully_processed_pending_account",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        uiContext.notifyFn(null, notification);

        setActive(false);

        props.closeFn();
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: onGetCatalogs },
        { endpoint: EndpointsEnum.VendorOnProcessVendorPending, fn: onProcessVendorPending },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getCatalogs();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const handleChange = (e: ChangeEvent<any>) => {
        const { name, value } = e.target;

        switch (name) {
            case "note":
                setNote(value);
                break;

            case "create_in_qbo":
                setCreateInQbo(!createInQbo);
                break;

            case "create_in_qbd":
                setCreateInQbd(!createInQbd);
                break;
        }
    };

    const handleCatalog = (catalog: ICatalog) => {
        console.log("handleCatalog: ", catalog);
        setSelectedCatalog(catalog);
    };

    const handlePriceGroup = (priceGroup: IPrice_Group) => {
        console.log("handlePriceGroup: ", priceGroup);
        setSelectedPriceGroup(priceGroup);
    };

    return (
        <div className={"VendorPendingModal"}>
            <div className={"d-flex justify-content-between align-items-center"}>
                <OwTitle title={"vendor_pending"} tag={"h3"} isSupplierVendorOverride={true} supplierModel={supplierModel} />
                <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeFn} />
            </div>
            <div className={"mt-2"}>
                <table className={"table " + (UIService.isMainViewLight() ? "" : "table-dark")}>
                    <tbody>
                        <tr>
                            <th>
                                <OwLabel title={"name"} />
                            </th>
                            <td>{props.vendorPending.name}</td>
                        </tr>
                        <tr>
                            <th>
                                <OwLabel title={"email"} />
                            </th>
                            <td>{props.vendorPending.email}</td>
                        </tr>
                        <tr>
                            <th>
                                <OwLabel title={"company_name"} />
                            </th>
                            <td>{props.vendorPending.company_name}</td>
                        </tr>
                        <tr>
                            <th>
                                <OwLabel title={"company_email"} />
                            </th>
                            <td>{props.vendorPending.company_email}</td>
                        </tr>
                        <tr>
                            <th>
                                <OwLabel title={"created"} />
                            </th>
                            <td>{UserService.parseLastUpdated(props.vendorPending.created_at)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mt-2">
                <OwLabel title={"catalog"} />
                <OwSelectOption
                    fn={handleCatalog}
                    titleProp={"name"}
                    valueProp={"guid"}
                    name={"catalog"}
                    options={catalogs}
                    emitObject={true}
                />
            </div>
            {selectedCatalog ? (
                <div className="mt-2">
                    <OwLabel title={"price_group"} />
                    <OwSelectOption
                        fn={handlePriceGroup}
                        titleProp={"value"}
                        valueProp={"guid"}
                        name={"price_group"}
                        options={selectedCatalog.Price_Groups || []}
                        emitObject={true}
                    />
                </div>
            ) : null}
            {supplierModel.Supplier_Integration.has_qbo ? (
                <div className="mt-2">
                    <OwCheckbox name={"create_in_qbo"} label={"create_in_quickbooks_online"} fn={handleChange} checked={createInQbo} />
                </div>
            ) : null}
            {supplierModel.Supplier_Integration.has_qbd ? (
                <div className="mt-2">
                    <OwCheckbox name={"create_in_qbd"} label={"create_in_quickbooks_desktop"} fn={handleChange} checked={createInQbd} />
                </div>
            ) : null}
            <div className="mt-2">
                <OwLabel title={"note"} />
                <OwTextArea fn={handleChange} name={"note"} value={note} />
            </div>
            <div className="mt-2">
                <OwButton
                    active={active}
                    disableOnActive={true}
                    title={"approve"}
                    fn={() => {
                        processVendorPending("approve");
                    }}
                />
                <OwButton
                    active={active}
                    disableOnActive={true}
                    title={"reject"}
                    className={"btn-danger ms-2 me-2"}
                    fn={() => {
                        processVendorPending("reject");
                    }}
                />
            </div>
            <div className="mt-2">
                <OwLabel
                    className={"text-warning"}
                    leftIconClass={"fad fa-exclamation-triangle"}
                    title={"additional_settings_after_created"}
                />
            </div>
        </div>
    );
};
